import React from "react";
import LandingHeader from "./header";

class LandingHeaderController extends React.Component{

    render(){
        return (
            <LandingHeader {...this.props}/>
        )
    }
}

export default LandingHeaderController;